import { ApolloProvider } from '@apollo/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { DropdownProvider, ToastProvider } from '@serodigital/ui-components';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApiHooksStore } from '../../shared/api-clients/store';
import { Routes } from './routes';

import { BrowserTracing } from '@sentry/tracing';
import '@serodigital/ui-components/dist/ui-components.esm.css';

import * as Sentry from '@sentry/react';
import { getGqlClient } from '../../shared/api-clients/gql';
import { ListFilterProvider } from './contexts/listFilter';
import { ManagementClient } from './contexts/managementClient';
import './index.css';
import { RBACProvider } from './contexts/rbac';

Sentry.init({
  dsn: 'https://e90b5faa33b9410f8a765f2766326712@o530025.ingest.sentry.io/6323726',
  integrations: [new BrowserTracing()],
  environment: APP_CONFIG.environment,

  tracesSampleRate: 0.1,
});

async function render() {
  const client = await getGqlClient();

  ReactDOM.render(
    <BrowserRouter>
      <Auth0Provider
        domain={APP_CONFIG.auth0Domain}
        clientId={APP_CONFIG.auth0ClientId}
        redirectUri={APP_CONFIG.appBaseUrl}
        audience={APP_CONFIG.auth0Audience}
      >
        <RBACProvider>
          <ApolloProvider client={client.client}>
            <ApiHooksStore.Provider>
              <ToastProvider>
                <DropdownProvider>
                  <ListFilterProvider>
                    <ManagementClient value={{ client }}>
                      <Routes />
                    </ManagementClient>
                  </ListFilterProvider>
                </DropdownProvider>
              </ToastProvider>
            </ApiHooksStore.Provider>
          </ApolloProvider>
        </RBACProvider>
      </Auth0Provider>
    </BrowserRouter>,
    document.getElementById('host'),
  );
}

render();
